import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { Tracking } from '../../global/tracking/tracking';

const DEFAULT_TITLE = 'Domestic & General';

export function handleTitleOnRouteEvents(router: Router, route: ActivatedRoute) {
  router.events
    .pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => {
        const returnChildData = (
          child: ActivatedRoute | null,
          currentData: Record<string, any>
        ): Record<string, any> => {
          if (!child) return currentData;

          if (child.firstChild) {
            return returnChildData(child.firstChild, currentData);
          }

          if (child.snapshot.data) {
            currentData = child.snapshot.data;
            return currentData;
          }

          return currentData;
        };
        const { firstChild } = route;

        const data = returnChildData(firstChild, {});

        if (data?.['title']) {
          return `${data?.['title']} | ${DEFAULT_TITLE}`;
        }

        return DEFAULT_TITLE;
      })
    )
    .subscribe({
      next: (title: string) => {
        document.title = title;
        Tracking.capturePageView();
      },
    });
}
